import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {environment} from "../../environments/environment";
import {PatreonSeason, PricesUrl} from "../core/models/models";

@Injectable({
  providedIn: 'root'
})
export class SeasonService {

  constructor(private httpClient: HttpClient) {
  }

  async getSeasonInfo(): Promise<PatreonSeason> {
    return firstValueFrom(this.httpClient.get<PatreonSeason>(environment.apiUrl + `admin/season`));
  }

  async updateSeasonInfo(season: PatreonSeason): Promise<PatreonSeason> {
    return firstValueFrom(this.httpClient.post<PatreonSeason>(environment.apiUrl + `admin/season`, season));
  }

  async resetSeason(): Promise<Object> {
    return firstValueFrom(this.httpClient.post(environment.apiUrl + `admin/reset`, {}));
  }

  async get_prices_url(): Promise<PricesUrl> {
    return firstValueFrom(this.httpClient.get<PricesUrl>(environment.apiUrl + `prices/current`));
  }

}
